import React from "react";
import ReactPaginate from "react-paginate";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import "./styles.scss";

const Pagination = ({
  pageCount,
  handlePageClick,
  currentPage,
  previousLabel = <BsChevronLeft></BsChevronLeft>,
  nextLabel = <BsChevronRight></BsChevronRight>,
}) => {
  return (
    <ReactPaginate
      previousLabel={previousLabel}
      nextLabel={nextLabel}
      breakLabel={"..."}
      pageCount={pageCount}
      marginPagesDisplayed={1}
      forcePage={currentPage - 1}
      pageRangeDisplayed={3}
      onPageChange={handlePageClick}
      breakClassName={"page-item"}
      ag
      breakLinkClassName={"page-link"}
      containerClassName={"pagination"}
      pageClassName={"page-item"}
      pageLinkClassName={"page-link"}
      previousClassName={"page-item"}
      previousLinkClassName={"page-link"}
      nextClassName={"page-item"}
      nextLinkClassName={"page-link"}
      activeClassName={"active"}
    />
  );
};

export default Pagination;
